import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiInfo } from 'react-icons/fi';
import { AiOutlineTrophy } from 'react-icons/ai';
import { t } from 'i18next';
import { IconVerified } from '@/components/custom/icon';
import { Button } from '@/components/ui/button';
import { BadgeGroup, Badge } from '@/components/ui/badge';
import { ModuleCard, ModuleCardAlert, ModuleCardHeader, ModuleCardHeaderContent, ModuleCardText, ModuleCardTitle } from '@/components/custom/module';
import { MedalContainer } from '@/components/custom/medal';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { CourseModulePlayfulCard } from '../Playful/CourseModulePlayfulCard';

export function CourseMonitoringModuleCard(props) {
  const navigate = useNavigate();
  const playfulStudent = usePlayfulStudent();
  const { module, courseId, canAccess, index = 0, filesCount = 0, activitiesCount = 0, bookletsCount = 0, details, isLoadingDetails = false, onRequestDetails = () => {} } = props;

  const getModuleStatus = module => {
    const now = new Date();
    let badgeVariant = '';
    let badgeText = '';
    let disclaimer = false;

    if (module?.learning_system_users?.length === 0) {
      badgeVariant = 'warning';
      badgeText = 'Novo';
    }
    if (module?.progress === 100 && now >= new Date(module?.finished_at)) {
      badgeVariant = 'success';
      badgeText = 'Concluído';
    }
    if (module?.progress === 100 && now < new Date(module?.finished_at)) {
      badgeVariant = 'warning';
      badgeText = 'Em andamento';
      disclaimer = true;
    }
    if (module?.progress < 100 && module?.progress > 0) {
      badgeVariant = 'warning';
      badgeText = 'Em andamento';
    }

    return { badgeVariant, badgeText, disclaimer };
  };

  const { badgeVariant, badgeText, disclaimer } = getModuleStatus(module);

  // Linha de módulo lúdica: título + badge, progresso e ação numa lista.
  if (playfulStudent) {
    const finishedCount = module?.learning_system_items_finished_count ?? 0;
    const totalCount = module?.learning_system_items_total_count ?? 0;
    const playfulBadgeVariant = badgeVariant === 'success' ? 'success-soft' : 'amber-soft';

    return (
      <CourseModulePlayfulCard
        moduleId={module.id}
        title={module?.title}
        index={index}
        // Sem a tela "sobre" no fluxo infantil: módulo abre direto na sala,
        // que se encarrega de criar a matrícula quando não existe.
        onClick={() => navigate(`/show-course/${module.id}/classroom`)}
        badge={badgeText ? { text: badgeText, variant: playfulBadgeVariant } : undefined}
        progress={{ finishedCount, totalCount, disclaimer }}
        locked={canAccess ? undefined : { message: 'Conclua o módulo anterior' }}
        cta={canAccess ? { label: 'Acessar', onClick: () => navigate(`/show-course/${module.id}/classroom`) } : undefined}
        filesCount={filesCount}
        activitiesCount={activitiesCount}
        bookletsCount={bookletsCount}
        details={details}
        isLoadingDetails={isLoadingDetails}
        onRequestDetails={onRequestDetails}
      />
    );
  }

  return (
    <ModuleCard onClick={() => navigate(`/curso/${courseId}/modulo/${module.id}/sobre`)}>
      <ModuleCardHeader className="w-[350px]">
        <ModuleCardHeaderContent>
          <div className="flex items-start gap-1">
            {module?.['official_content'] && <IconVerified />}
            <ModuleCardTitle title={module?.title}>{module?.title}</ModuleCardTitle>
          </div>
        </ModuleCardHeaderContent>
      </ModuleCardHeader>

      {disclaimer ? (
        <ModuleCardAlert>
          <FiInfo
            data-tooltip-content={`O certificado do módulo estará disponível a partir de ${new Date(module?.finished_at).toLocaleDateString('pt-br')}`}
            size={16}
          />
          <span>
            Parabéns, todas as aulas foram concluídas. <b>Mantenha-se atento, mais conteudos podem chegar em breve.</b>
          </span>
        </ModuleCardAlert>
      ) : (
        <BadgeGroup>
          {badgeText && (
            <Badge
              variant={badgeVariant}
              size="xs"
              className="cursor-pointer"
            >
              {badgeText}
            </Badge>
          )}
        </BadgeGroup>
      )}

      <ModuleCardText>
        {module?.progress === 0 ? <strong>0</strong> : <strong>{module?.learning_system_items_finished_count}</strong>}/{module?.learning_system_items_total_count} {t('lms.lms')}
      </ModuleCardText>

      {module?.progress === 100 && (
        <MedalContainer
          size="sm"
          src="more"
          value={<AiOutlineTrophy />}
        />
      )}

      <Button
        variant="outline"
        wide
        disabled={!canAccess}
        className="hidden sm:flex"
      >
        Acessar
      </Button>

      {/* <ModuleCardFooter>
        {newModule ? (
          <Button
            variant="outline"
            wide
            fullWidth
            className="hidden sm:flex"
          >
            Visualizar
          </Button>
        ) : (
          <>
            <ModuleCardText>{t('lms.buttonContinue')}</ModuleCardText>
            <ModuleCardLink to={`/show-course/${374}/classroom`}>
              <CardIcon>
                <FiPlayCircle size={16} />
              </CardIcon>
              <ModuleCardLinkText title={'Aula 2 - Física clássica'}>Aula 2 - Física clássica</ModuleCardLinkText>
            </ModuleCardLink>
          </>
        )}
      </ModuleCardFooter> */}
    </ModuleCard>
  );
}
